<script lang="ts" setup>
import {defineProps, ref} from "vue";
import { CheckMobileDevice } from "@/utils/handle";

const props = defineProps({
  msgText: {
    type: String,
    default: ''
  }
})

</script>

<template>
  <div class="msg-toast-box">
    <div :class="CheckMobileDevice() ? 'msg-toast-m' : 'msg-toast'">
      <div class="text">{{ msgText }}</div>
    </div>
  </div>

</template>

<style scoped lang="less">
.msg-toast-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.msg-toast {
  max-width: 80vw;
  .text {
    display: inline-block;
    background: rgba(0,0,0, .8);
    color: #fff;
    font-size: 20px;
    padding: 16px 25px;
    border-radius: 10px;
  }
}
.msg-toast-m {
  max-width: 80vw;
  .text {
    display: inline-block;
    background: rgba(0,0,0, .8);
    color: #fff;
    font-size: .7rem;
    padding: .5rem .65rem;
    border-radius: .4rem;
  }
}
</style>